export default "__VITE_ASSET__CElRmZ$3__"